import { MegamenuItem, NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";
import __megamenu from "./jsons/__megamenu.json";


const megaMenuDemo: MegamenuItem[] = [
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Company",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Company,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "App Name",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.AppName,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/5059013/pexels-photo-5059013.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "City",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.City,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/5159141/pexels-photo-5159141.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Contruction",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Contruction,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/7473041/pexels-photo-7473041.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Country",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Country,
    })),
  },
];

const demoChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "HomePage",
  },
  // {
  //   id: ncNanoId(),
  //   href: "/home-2",
  //   name: "Real Estate",
  //   isNew: true,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/home-3",
  //   name: "Home - 3",
  //   isNew: true,
  // },
];

const otherPageChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing-1",
    name: "+ Add Listings",
  },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contact us",
  },
  {
    id: ncNanoId(),
    href: "/login",
    name: "Login",
  },
  {
    id: ncNanoId(),
    href: "/signup",
    name: "Signup",
  },
];

const infoESupportoMenu: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contattaci",
  },
  {
    id: ncNanoId(),
    href: "/chi-siamo",
    name: "Chi Siamo",
  },
];

const policyMenu: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/privacy-policy",
    name: "Privacy Policy",
  },
  {
    id: ncNanoId(),
    href: "/termini-condizioni",
    name: "Termini e Condizioni d'Uso",
  },
  {
    id: ncNanoId(),
    href: "/cookie-policy",
    name: "Cookie Policy",
  },
];

const templatesChildrenMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing-1",
    name: "+ Add Listings",
    type: "dropdown",
    children: [
      {
        id: ncNanoId(),
        href: "/add-listing-1",
        name: "Add Listings 1",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-2",
        name: "Add Listings 2",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-3",
        name: "Add Listings 3",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-4",
        name: "Add Listings 4",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-5",
        name: "Add Listings 5",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-6",
        name: "Add Listings 6",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-7",
        name: "Add Listings 7",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-8",
        name: "Add Listings 8",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-9",
        name: "Add Listings 9",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-10",
        name: "Add Listings 10",
      },
    ],
  },
  //
  { id: ncNanoId(), href: "/checkout", name: "Checkout" },
  { id: ncNanoId(), href: "/pay-done", name: "Pay done" },
  //
  { id: ncNanoId(), href: "/account", name: "Account Page" },
];

export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
    type: "dropdown",
    children: demoChildMenus,
    isNew: true,
  },
  
  {
    id: ncNanoId(),
    href: "/appartamenti",
    name: "I Nostri Appartamenti",
    type: "dropdown",
    isNew: true,
    children: [
      //
      {
        id: ncNanoId(),
        href: "/appartamenti",
        name: "Appartamenti",
        isNew: true,
        type: "dropdown",
        children: [
          {
            id: ncNanoId(),
            href: "/dettagli-appartamento/3",
            name: "Bouganville in Villa Greco",
            isNew: true,
          },
          {
            id: ncNanoId(),
            href: "/dettagli-appartamento/4",
            name: "Il gelso in Villa Greco",
            isNew: true,
          },
          {
            id: ncNanoId(),
            href: "/dettagli-appartamento/5",
            name: "A casa di Peppino in Villa Greco",
            isNew: true,
          },
          {
            id: ncNanoId(),
            href: "/dettagli-appartamento/6",
            name: "L'ulivo in Villa Greco",
            isNew: true,
          },
          // {
          //   id: ncNanoId(),
          //   href: "/dettagli-appartamento/2",
          //   name: "Belvedere 2 in Villa Greco",
          //   isNew: true,
          // },
          // {
          //   id: ncNanoId(),
          //   href: "/dettagli-appartamento/1",
          //   name: "Belvedere 1 in Villa Greco",
          //   isNew: true,
          // },
        ],
      },
      //
    ],
  },
  // {
  //   id: ncNanoId(),
  //   href: "/author",
  //   name: "pagine ancora da collegare",
  //   type: "dropdown",
  //   children: templatesChildrenMenus,
  // },

  // {
  //   id: ncNanoId(),
  //   href: "/blog",
  //   name: "altre pagine da collegare",
  //   type: "dropdown",
  //   children: otherPageChildMenus,
  // },


  
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Info & Supporto",
    type: "dropdown",
    children: infoESupportoMenu,
  },
  {
    id: ncNanoId(),
    href: "/",
    name: "Policy",
    type: "dropdown",
    children: policyMenu,
  },
];
